import { settings } from '../../main/configs/settings'

export default class LinkBuilder {
  static buildMailtoLink(email: string) {
    return `mailto:${email}`
  }

  static buildWhatsAppLink(number: string) {
    return `https://api.whatsapp.com/send?phone=${number}`
  }

  static buildGoogleMapsLink(lat: number, lng: number) {
    return `https://www.google.com/maps?q=${lat},${lng}`
  }

  static buildAssetsUrl(url: string) {
    return `${settings.ASSETS_URL}/${url}`
  }
}
